import { render, staticRenderFns } from "./IgnorePageViewsTrigger.vue?vue&type=template&id=9a9827ca&scoped=true&"
import script from "./IgnorePageViewsTrigger.vue?vue&type=script&lang=js&"
export * from "./IgnorePageViewsTrigger.vue?vue&type=script&lang=js&"
import style0 from "./IgnorePageViewsTrigger.vue?vue&type=style&index=0&id=9a9827ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9827ca",
  null
  
)

export default component.exports